import { getNameInitials } from '@/shared/lib/name';

/**
 * Notification Center Widget Composable
 * Manages state and logic for the global notification center widget
 */
export function useNotificationCenter() {
  const getInitials = (name: string): string => getNameInitials(name);

  const getRelativeTime = (dateString: string): string => {
    const notificationDate = new Date(dateString).getTime();
    const now = Date.now();
    const diffMs = now - notificationDate;

    if (diffMs < 0) return 'agora';

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `Há ${days} dia${days > 1 ? 's' : ''}`;
    } else if (hours > 0) {
      return `Há ${hours} hora${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      return `Há ${minutes} minuto${minutes > 1 ? 's' : ''}`;
    } else {
      return 'agora';
    }
  };

  return {
    getInitials,
    getRelativeTime,
  };
}
